/**
 * Wallet Pass Service
 * Issues and serves Apple Wallet and Google Wallet loyalty passes for Convercus programs. Internal administrators register programs, mint program API keys, maintain store locations, configure wallet design and levels, read adoption analytics and query the audit trail; customer-facing clients download a pass through the program-scoped download routes, and the wallets themselves keep it current through the Apple PassKit web service and the Google Wallet Objects callback. Every path below already carries the gateway base prefix `/wallet-pass-service`.
 *
 * The version of the OpenAPI document: 1.0.39938
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { InlineResponse2001 } from '../model/models';
import { InlineResponse401 } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import {
    AuditLogsServiceInterface,
    ListAuditLogsRequestParams,
    ListAuditLogsLegacyRequestParams,
    ListProgramAuditLogsRequestParams
} from './audit-logs.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class AuditLogsService implements AuditLogsServiceInterface {

    protected basePath = 'https://staging.convercus.io';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * List audit logs
     * Returns one page of audit rows in a window of at most 30 days. A SuperInternal API key sees all programs. An Internal key is limited to its program. A JWT is limited to the program matching &#x60;organization&#x60;. &#x60;from&#x60; and &#x60;to&#x60; are required.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listAuditLogs(requestParameters: ListAuditLogsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<InlineResponse2001>;
    public listAuditLogs(requestParameters: ListAuditLogsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<InlineResponse2001>>;
    public listAuditLogs(requestParameters: ListAuditLogsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<InlineResponse2001>>;
    public listAuditLogs(requestParameters: ListAuditLogsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const from = requestParameters.from;
        if (from === null || from === undefined) {
            throw new Error('Required parameter from was null or undefined when calling listAuditLogs.');
        }
        const to = requestParameters.to;
        if (to === null || to === undefined) {
            throw new Error('Required parameter to was null or undefined when calling listAuditLogs.');
        }
        const xAdminKey = requestParameters.xAdminKey;
        const entityType = requestParameters.entityType;
        const entityId = requestParameters.entityId;
        const action = requestParameters.action;
        const status = requestParameters.status;
        const source = requestParameters.source;
        const actorType = requestParameters.actorType;
        const resourceType = requestParameters.resourceType;
        const operation = requestParameters.operation;
        const adminChannel = requestParameters.adminChannel;
        const accountId = requestParameters.accountId;
        const offset = requestParameters.offset;
        const limit = requestParameters.limit;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (from !== undefined && from !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>from, 'from');
        }
        if (to !== undefined && to !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>to, 'to');
        }
        if (entityType !== undefined && entityType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>entityType, 'entityType');
        }
        if (entityId !== undefined && entityId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>entityId, 'entityId');
        }
        if (action !== undefined && action !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>action, 'action');
        }
        if (status !== undefined && status !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>status, 'status');
        }
        if (source !== undefined && source !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>source, 'source');
        }
        if (actorType !== undefined && actorType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>actorType, 'actorType');
        }
        if (resourceType !== undefined && resourceType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>resourceType, 'resourceType');
        }
        if (operation !== undefined && operation !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>operation, 'operation');
        }
        if (adminChannel !== undefined && adminChannel !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>adminChannel, 'adminChannel');
        }
        if (accountId !== undefined && accountId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>accountId, 'accountId');
        }
        if (offset !== undefined && offset !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>offset, 'offset');
        }
        if (limit !== undefined && limit !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>limit, 'limit');
        }

        let headers = this.defaultHeaders;
        if (xAdminKey !== undefined && xAdminKey !== null) {
            headers = headers.set('x-admin-key', String(xAdminKey));
        }

        let credential: string | undefined;
        // authentication (Admin) required
        credential = this.configuration.lookupCredential('Admin');
        if (credential) {
            headers = headers.set('x-admin-key', credential);
        }

        // authentication (Admin JWT) required
        credential = this.configuration.lookupCredential('Admin JWT');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (Super Admin) required
        credential = this.configuration.lookupCredential('Super Admin');
        if (credential) {
            headers = headers.set('x-admin-key', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<InlineResponse2001>(`${this.configuration.basePath}/wallet-pass-service/v1/admin/audit/logs`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List audit logs legacy
     * Superseded by GET /v1/admin/audit/logs (or the program-scoped v1 route). Returns one page of audit rows in a window of at most 30 days. Program-scoped keys only see rows for their program.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public listAuditLogsLegacy(requestParameters: ListAuditLogsLegacyRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<InlineResponse2001>;
    public listAuditLogsLegacy(requestParameters: ListAuditLogsLegacyRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<InlineResponse2001>>;
    public listAuditLogsLegacy(requestParameters: ListAuditLogsLegacyRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<InlineResponse2001>>;
    public listAuditLogsLegacy(requestParameters: ListAuditLogsLegacyRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const from = requestParameters.from;
        if (from === null || from === undefined) {
            throw new Error('Required parameter from was null or undefined when calling listAuditLogsLegacy.');
        }
        const to = requestParameters.to;
        if (to === null || to === undefined) {
            throw new Error('Required parameter to was null or undefined when calling listAuditLogsLegacy.');
        }
        const xAdminKey = requestParameters.xAdminKey;
        const entityType = requestParameters.entityType;
        const entityId = requestParameters.entityId;
        const action = requestParameters.action;
        const status = requestParameters.status;
        const source = requestParameters.source;
        const actorType = requestParameters.actorType;
        const resourceType = requestParameters.resourceType;
        const operation = requestParameters.operation;
        const adminChannel = requestParameters.adminChannel;
        const accountId = requestParameters.accountId;
        const offset = requestParameters.offset;
        const limit = requestParameters.limit;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (from !== undefined && from !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>from, 'from');
        }
        if (to !== undefined && to !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>to, 'to');
        }
        if (entityType !== undefined && entityType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>entityType, 'entityType');
        }
        if (entityId !== undefined && entityId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>entityId, 'entityId');
        }
        if (action !== undefined && action !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>action, 'action');
        }
        if (status !== undefined && status !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>status, 'status');
        }
        if (source !== undefined && source !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>source, 'source');
        }
        if (actorType !== undefined && actorType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>actorType, 'actorType');
        }
        if (resourceType !== undefined && resourceType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>resourceType, 'resourceType');
        }
        if (operation !== undefined && operation !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>operation, 'operation');
        }
        if (adminChannel !== undefined && adminChannel !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>adminChannel, 'adminChannel');
        }
        if (accountId !== undefined && accountId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>accountId, 'accountId');
        }
        if (offset !== undefined && offset !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>offset, 'offset');
        }
        if (limit !== undefined && limit !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>limit, 'limit');
        }

        let headers = this.defaultHeaders;
        if (xAdminKey !== undefined && xAdminKey !== null) {
            headers = headers.set('x-admin-key', String(xAdminKey));
        }

        let credential: string | undefined;
        // authentication (Admin) required
        credential = this.configuration.lookupCredential('Admin');
        if (credential) {
            headers = headers.set('x-admin-key', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<InlineResponse2001>(`${this.configuration.basePath}/wallet-pass-service/admin/audit/logs`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List program audit logs
     * Same filters as the global audit list, always scoped to this program. Window at most 30 days.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listProgramAuditLogs(requestParameters: ListProgramAuditLogsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<InlineResponse2001>;
    public listProgramAuditLogs(requestParameters: ListProgramAuditLogsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<InlineResponse2001>>;
    public listProgramAuditLogs(requestParameters: ListProgramAuditLogsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<InlineResponse2001>>;
    public listProgramAuditLogs(requestParameters: ListProgramAuditLogsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling listProgramAuditLogs.');
        }
        const from = requestParameters.from;
        if (from === null || from === undefined) {
            throw new Error('Required parameter from was null or undefined when calling listProgramAuditLogs.');
        }
        const to = requestParameters.to;
        if (to === null || to === undefined) {
            throw new Error('Required parameter to was null or undefined when calling listProgramAuditLogs.');
        }
        const xAdminKey = requestParameters.xAdminKey;
        const entityType = requestParameters.entityType;
        const entityId = requestParameters.entityId;
        const action = requestParameters.action;
        const status = requestParameters.status;
        const source = requestParameters.source;
        const actorType = requestParameters.actorType;
        const resourceType = requestParameters.resourceType;
        const operation = requestParameters.operation;
        const adminChannel = requestParameters.adminChannel;
        const accountId = requestParameters.accountId;
        const offset = requestParameters.offset;
        const limit = requestParameters.limit;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (from !== undefined && from !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>from, 'from');
        }
        if (to !== undefined && to !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>to, 'to');
        }
        if (entityType !== undefined && entityType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>entityType, 'entityType');
        }
        if (entityId !== undefined && entityId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>entityId, 'entityId');
        }
        if (action !== undefined && action !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>action, 'action');
        }
        if (status !== undefined && status !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>status, 'status');
        }
        if (source !== undefined && source !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>source, 'source');
        }
        if (actorType !== undefined && actorType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>actorType, 'actorType');
        }
        if (resourceType !== undefined && resourceType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>resourceType, 'resourceType');
        }
        if (operation !== undefined && operation !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>operation, 'operation');
        }
        if (adminChannel !== undefined && adminChannel !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>adminChannel, 'adminChannel');
        }
        if (accountId !== undefined && accountId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>accountId, 'accountId');
        }
        if (offset !== undefined && offset !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>offset, 'offset');
        }
        if (limit !== undefined && limit !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>limit, 'limit');
        }

        let headers = this.defaultHeaders;
        if (xAdminKey !== undefined && xAdminKey !== null) {
            headers = headers.set('x-admin-key', String(xAdminKey));
        }

        let credential: string | undefined;
        // authentication (Admin) required
        credential = this.configuration.lookupCredential('Admin');
        if (credential) {
            headers = headers.set('x-admin-key', credential);
        }

        // authentication (Admin JWT) required
        credential = this.configuration.lookupCredential('Admin JWT');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<InlineResponse2001>(`${this.configuration.basePath}/wallet-pass-service/v1/admin/programs/${encodeURIComponent(String(programId))}/audit/logs`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
